export default {
  adminMetadata: {
    generalRegistry: 'General registry',
    registerOfCompetencies: 'Register of competencies',
    registerOfOpenQuestions: 'Register of open questions',
    openQuestionsSettings: 'Open questions settings',
    addingOpenQuestions: 'Adding open questions',
    fixVersion: 'Fixate the version?',
    selectCompany: 'Select a company',
    buttons: {
      addSection: 'Add a section',
      addOpenQuestion: 'Add a open question',
      addSkillBlock: 'Add a block',
      addSkill: 'Add a competence',
      addOpenQuestions: 'Add an open questions',
      addQuestion: 'Add a skill indicator',
      addQuestions: 'Add a skill indicators',
      addMaterials: 'Add materials',
      uploadOpenQuestions: 'Upload questions',
      editLevels: 'Edit levels',
      scale: 'Scale',
      editHints: 'Edit hints',
      profile: "Supervisor's profile",
      addSpec: 'Add specialization',
      editSpec: 'Edit specialization',
      deleteSpec: 'Delete specialization',
      changePulseSpec: 'Pulse-specialization',
      fix: 'Yes, fixate',
    },
    stubs: {
      noVersion: 'To add a block, you need to fixate the version',
      selectCompany: 'Select a company',
      noVersionSpec: 'To add a specialization, you need to fixate the version',
      noSkills: 'To select indicators, you need to add blocks and competencies',
      noMaterials: 'No materials',
      noQuestions: 'There are no indicators for this specialization',
      noSpecs:
        'There are no specializations in your company yet, click on the «Add» button to create',
    },
    subtitles: {
      spec: 'To the profile',
      skill_block: 'To the competence block',
      skill: 'To the competence',
    },
    labels: {
      skill_block: 'A competency block with this name has already been created',
      skill: 'A competency with this name has already been created',
      skill_question: 'An indicator with the same name has already been created',
      min: 'The lower indicator of the norm',
      max: 'The high indicator of the norm',
    },
    emptyBlock: {
      title: 'Choose<br> a specialization',
      description: 'To manage blocks,<br> competencies and indicators in it',
    },
    tooltips: {
      materials:
        'Materials for creating the development plan, but if materials are not added, the development plan can be filled in manually later',
      scale: 'Setting the scale',
      deleteSkillBlock: 'Delete the competence block',
      deleteSkill: 'Delete the competence',
      deleteQuestion: 'Delete the indicator',
      skill_block:
        'The phrasing will change in all specializations containing the competence block.',
      skill: 'The phrasing will change in all specializations containing the competence.',
      skill_question: 'The phrasing will change in all specializations containing the indicator.',
      high: 'Competence is constantly demonstrated and allows the employee to successfully solve problems',
      middle: 'Competence is limited and applied in standard situations',
      low: 'Competence is demonstrated to a limited extent/irregularly',
      zero: 'Does not show competence, does not understand its importance',
      competenciesArea:
        'The competency area is the specified values of the minimum recommended and target levels, which are the reference requirements for the level of competencies, skills and experience recommended for performing functions and authorities within a role (or group of roles)',
      profile:
        'When you click on this button, the system will recommend and automatically set reference requirements for the level of competencies for management profiles',
      pulse: 'Pulse-specialization',
      active:
        'The active specialization will be available on the platform for assigning 360 assessments and completing self-assessments. If the checkbox is not checked, the specialization will not be available for evaluation',
      devMap:
        'Includes the ability to create a development plan for the chosen specialization. The “Active” checkbox for the specialization must also be checked',
      deleteMaterial: 'Delete material',
      editMaterial: 'Edit material',
      grades:
        '<article class="py-2"><p>Determines the level of material for the user\'s development, depending on his average score according to the results of 360. The material will be available in the development map according to the logic:</p><ul><li>difficulty level 0 = rating range 0-0.99</li><li>difficulty level 1 = rating range 1-1.99</li><li>difficulty level 2 = rating range 2 - 2.99</li><li>difficulty level 3 = rating 3</li><li>No difficulty level selected = will be shown at any evaluation</li></ul><p class="mt-4">You can href one material to several difficulty levels at once</p></article>',
      editTooltip: 'Edit the hint',
      editHints: 'Edit hints and answers',
      hint: 'A hint that an employee will see for answer options when passing the 360 assessment',
      addOpenQuestions: {
        spec: {
          active:
            'The questions will be displayed as a separate block at the end of the assessment 360',
          disabled: 'Adding questions is only available after adding an indicators',
        },
        skill_block: 'Add an open questions to the competence block',
        skill: 'Add an open questions to the competence',
      },
      expertGroups:
        'The open questions are displayed depending on the role in the 360 assessment being conducted and the «Show to whom» setting',
    },
    deleteBaseProfileItem: {
      title: 'Deleting entries from the specialization profile',
      text: 'All nested items will be deleted, do you really want to delete the selected entry?',
    },
    chooseQuestions: 'Choose indicators',
    formLabels: {
      skill_block: 'Competence block',
      skill: 'Competence',
      skill_question: 'Indicator',
      junior: 'Junior',
      middle: 'Middle',
      senior: 'Senior',
      name: 'Name of the material',
      href: 'Link',
      type: 'Type of material',
      grades: 'Grades',
    },
    deleteSpecTitle: 'This specialization will be deleted. Are you sure?',
    tableHeaders: {
      name: 'Name',
      active: 'Active',
      devMap: 'DP',
      materials: 'Materials',
      actions: 'Actions',
      link: 'Link',
      materialType: 'Material type',
      grade: 'Difficulty grade',
      options: 'Answer options',
      tooltip: 'Hint',
      expertGroups: 'Show to whom',
    },
    changeMaterials: {
      title: 'Specialization profile',
      name: 'Name',
      description: 'General materials for development by specialization',
    },
    newMaterial: 'Enter material name',
    newTypeMaterial: 'Training course',
    newSpec: 'New specialization',
    editSpec: 'Editing a specialization',
    matchSpec: 'This specialization has already been created',
    changeMaterialsDevPlan: {
      title: 'Element editing',
      description: 'Materials for the development map',
      elementName: 'Element name',
    },
    editHint: 'Editing hints',
    // messages
    successMessages: {
      fixVersion: 'The version successfully fixed',
      addSpecs: 'Specializations added successfully',
      addOpenQuestions: 'Open questions successfully added',
      editOpenQuestions: 'The open questions successfully edited',
      saveOpenQuestionsSettings: 'The open questions settings successfully saved',
      deleteOpenQuestions: 'The open questions successfully deleted',
      moveOpenQuestions: 'The open questions successfully moved',
      deleteRegistryItem: 'Registry items successfully deleted',
      renameRegistryItem: 'The registry item successfully renamed',
      moveRegistryItem: 'The registry item successfully moved',
      deleteSkillQuestions: 'The items successfully deleted',
      deleteSkillBlock: 'The competence block successfully deleted',
      deleteSkill: 'The competence successfully deleted',
      deleteQuestion: 'The indicator successfully deleted',
      copyRegistryItem: 'The registry item successfully copied',
      moveBaseProfileTree: {
        skillBlock: 'The competence block successfully moved',
        skill: 'The competence successfully moved',
        question: 'The indicator block successfully moved',
      },
      changeIndicators: 'Indicators successfully changed',
      skill_block: 'The phrasing successfully changed',
      skill: 'The phrasing successfully changed',
      skill_question: 'The indicator successfully changed',
      changeScale: 'Scale successfully changed',
      deleteSpec: 'Specialization successfully deleted',
      editSpec: 'Specialization successfully changed',
      changeMaterials: 'Materials successfully changed',
      changePulseSpec: 'Pulse-specialization successfully changed',
      createSpec: 'Specialization successfully created',
      saveHint: 'The hints successfully saved',
    },
    errorMessages: {
      getOpenQuestionsTree: 'Failed to get the register of open questions',
      getOpenQuestionsBySpec: 'Failed to get open questions for specialization',
      addOpenQuestions: 'Failed to add the open questions',
      editOpenQuestions: 'Failed to edit the open questions',
      deleteOpenQuestions: 'Failed to delete the open questions',
      moveOpenQuestions: 'Failed to move open questions',
      importOpenQuestions: {
        incorrectTemplate: 'Incorrect template',
        emptyFileSection: 'Not all questions have the «Section» field filled in.',
        alreadyExist: 'Questions with this name already exist',
        default: 'Failed to upload open questions',
      },
      fixVersion: 'Failed to fixate the version',
      currentVersion: 'Failed to get the version',
      addSpecs: 'Failed to add specializations',
      updateSkillsVersion: 'Failed to update the version',
      fixateSkillsVersion: 'Failed to fixate the version',
      deleteRegistryItem: 'Failed to delete registry items',
      renameRegistryItem: 'Failed to rename the registry item',
      moveRegistryItem: 'Failed to move the registry item',
      copyRegistryItem: 'Failed to copy the registry item',
      sameParent: 'You cannot move elements inside the same parent element',
      changeType: 'It is forbidden to change the level',
      deleteSkillQuestions: 'Failed to delete the indicators',
      deleteSkillBlock: 'Failed to delete the competence block',
      deleteSkill: 'Failed to delete the competence',
      deleteQuestion: 'Failed to delete the indicator',
      moveBaseProfileTree: {
        skillBlock: 'Failed to move the competence block',
        skill: 'Failed to move the competence',
        question: 'Failed to move the indicator',
      },
      addQuestions: 'Failed to add indicators',
      deleteQuestions: 'Failed to delete indicators',
      changeName: 'Failed to change the phrasing',
      changeGrades: 'Failed to change the grades',
      changeScale: 'Failed to change scale',
      deleteSpec: 'Failed to delete specialization',
      editSpec: 'Failed to change specialization',
      changeMaterials: 'Failed to change materials',
      changePulseSpec: 'Failed to change pulse-specialization',
      createSpec: 'Failed to create specialization',
      saveHint: 'Failed to save the hints',
    },
    // confirm dialogs
    confirmDeleteRegistryItem: {
      title: 'Delete an item from the registry?',
      text: 'It will be impossible to cancel this action',
      section: {
        title: 'Delete the open questions section?',
        text: 'The section will only be deleted from the registry. The section will be saved in the specialization profiles where it was previously included.',
      },
      question: {
        title: 'Delete the open question?',
        text: 'The question will only be deleted from the registry. The question will be saved in the specialization profiles where it was previously included.',
      },
    },
    confirmDeleteRegistryItems: {
      title: 'Delete the items from the registry?',
      text: 'The items will only be deleted from the registry. The elements will remain in the specialization profiles they were previously included in.',
      openQuestionsText:
        'The items will only be deleted from the registry. The elements will remain in the specialization profiles they were previously included in.',
    },
    confirmMoveRegistryItem: {
      title: 'Move the item?',
      button: 'Yes, move',
    },
    confirmCopyRegistryItem: {
      title: 'Copy the question?',
      text: 'A copy will be added to the current section below the copied question.',
      button: 'Yes, copy',
    },
    confirmDeleteMaterial: {
      title: 'Delete the material?',
      text: 'It will be impossible to cancel this action',
    },
    // dialogs
    createRegistryItemDialog: {
      skill_block: {
        title: 'New competence blocks',
        subtitle: 'Skills',
        formLabels: {
          name: 'Name',
        },
        addButton: 'Add another one',
        successMessage: 'Competence blocks successfully created',
        errorMessage: 'Failed to create competence blocks',
      },
      skill: {
        title: 'New competencies',
        subtitle: 'Competence block',
        formLabels: {
          name: 'Name',
        },
        addButton: 'Add another one',
        successMessage: 'Competencies successfully created',
        errorMessage: 'Failed to create competencies',
      },
      skill_question: {
        title: 'New indicators',
        subtitle: 'Competence',
        formLabels: {
          name: 'Name',
        },
        addButton: 'Add another one',
        successMessage: 'Indicators successfully created',
        errorMessage: 'Failed to create indicators',
      },
      section: {
        title: {
          create: 'A new section of open questions',
          rename: 'Edit the open questions section',
        },
        formLabels: {
          name: 'Name',
        },
        addButton: 'Add another one',
        successMessages: {
          create: 'The section of open questions successfully created',
          rename: 'The section of open questions successfully edited',
        },
        errorMessages: {
          create: 'Failed to create the section of open questions',
          rename: 'Failed to edit the section of open questions',
        },
      },
      question: {
        title: {
          create: 'A new open question',
          rename: 'Edit the open question',
        },
        subtitle: 'Section',
        formLabels: {
          name: 'The text of the open question',
          description: 'A short description or a hint',
        },
        addButton: 'Add another one',
        removeButton: 'Delete the question',
        successMessages: {
          create: 'The open question successfully created',
          rename: 'The open question successfully edited',
        },
        errorMessages: {
          create: 'Failed to create the open question',
          rename: 'Failed to edit the open question',
        },
      },
      invalidMessages: {
        skill_block: 'A competency block with this name has already been created',
        skill: 'A competency with this name has already been created',
        skill_question: 'An indicator with the same name has already been created',
        section:
          'A section of open questions with this name has already been created. To save it, change the name.',
        question:
          'An open question with this text has already been created. To save it, change the text of the question.',
      },
      infoMessages: {
        section:
          'The section will change only in the registry. The section will not change in the specialization profiles in which it was previously included.',
        question:
          'The question will change only in the registry. The question will not change in the specialization profiles in which it was previously included.',
      },
    },
    changeRegistryItemDialog: {
      skill_block: 'Edit the phrasing',
      skill: 'Edit the phrasing',
      skill_question: 'Edit the indicator',
    },
    changeScaleDialog: {
      titles: {
        spec: 'Setting the scale',
        question: 'Setting the indicator scale',
      },
      descriptions: {
        spec: 'Define the competency area for the job profile',
        question: 'Define the competency area for the indicator',
      },
    },
    changeQuestionMetadataDialog: {
      title: 'Editing answer options and hints',
      description:
        'Answer options and hints to them that an employee will see when passing the 360 assessment.',
      table: {
        headers: {
          options: 'Answer options',
          tooltip: 'Hint',
          actions: 'Actions',
        },
      },
      confirmSaveDialog: {
        title: 'Save the changes?',
        text: 'Do you really want to change the answer options and hint texts? The changes will be applied to all indicators of this specialization profile, as well as to all other profiles that use these indicators.',
        button: 'Yes, change',
      },
      infoMessages: {
        spec: 'The changes will be applied to all indicators of this specialization profile, as well as to all profiles that use these indicators.',
      },
      successMessage: 'The changes successfully saved',
      errorMessages: {
        getQuestionTooltips: 'Failed to get data about the hints',
        getQuestionAnswerTexts: 'Failed to get data about the answer options',
        getAffectedSpecs: 'Failed to get data about the affected specializations',
        createQuestionTooltips: 'Failed to save the hints',
        createQuestionAnswerTexts: 'Failed to save the answer options',
      },
    },
    //
  },
};
